import { createRoot, type Root } from 'react-dom/client';
import './index.css';
import App from './App';
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { store } from 'Store';
import { Provider } from 'react-redux';
import { ThemeV2_0 } from 'ThemeV2.0';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { msalInstance } from './msalInstance';
// import { StrictMode } from 'react';

type IndexHotData = {
  root?: Root;
  cache?: ReturnType<typeof createCache>;
};

const cache =
  (import.meta.hot?.data as IndexHotData | undefined)?.cache ??
  createCache({
    key: 'css',
    prepend: true,
  });

if (import.meta.hot) {
  (import.meta.hot.data as IndexHotData).cache = cache;
}

const rootElement = document.getElementById('root');

if (rootElement !== null) {
  const hotData = import.meta.hot?.data as IndexHotData | undefined;
  let root = hotData?.root;
  if (!root) {
    root = createRoot(rootElement);
    if (import.meta.hot) {
      (import.meta.hot.data as IndexHotData).root = root;
    }
  }

  root.render(
    // <StrictMode>
    <StyledEngineProvider injectFirst>
      <CacheProvider value={cache}>
        <ThemeProvider theme={ThemeV2_0}>
          <CssBaseline />
          <Provider store={store}>
            <App msalInstance={msalInstance} />
          </Provider>
        </ThemeProvider>
      </CacheProvider>
    </StyledEngineProvider>,
    //  </StrictMode>,
  );
} else {
  console.error('Root element with ID "root" not found in the DOM');
}
